import React from "react";
import { ArrowRight, CreditCard, RotateCcw, ShieldCheck, Zap, BoxIcon } from "lucide-react";
import { Button } from "./Button";
import { CHECKOUT_URL } from "../data/content";
type PurchaseCtaProps = {
  label?: string;
  supportText?: string;
  className?: string;
};
type SupportIcon = {
  Icon: BoxIcon;
  color: string;
};
function getSupportIcon(segment: string): SupportIcon {
  const lower = segment.toLowerCase();
  if (lower.includes("seguro")) return {
    Icon: ShieldCheck,
    color: "#27B36A"
  };
  if (lower.includes("acceso")) return {
    Icon: Zap,
    color: "#F5B83D"
  };
  if (lower.includes("garant")) return {
    Icon: RotateCcw,
    color: "#5B9BF5"
  };
  return {
    Icon: CreditCard,
    color: "#5B9BF5"
  };
}
export function PurchaseCta({
  label = "💥 QUIERO MI ATLETISMO RESUELTO",
  supportText = "Pago 100% seguro · Mercado Pago | Tarjeta | Transferencia",
  className = ""
}: PurchaseCtaProps) {
  const goToCheckout = () => {
    window.location.href = CHECKOUT_URL;
  };
  const hasArrowInLabel = label.trim().endsWith("→");
  const displayLabel = hasArrowInLabel ? label.replace(/→\s*$/, "").trim() : label;
  const supportSegments = supportText.split("·").map(segment => segment.trim()).filter(Boolean);
  return <div className={`flex flex-col items-center gap-3 ${className}`} data-id="element-179" data-mp="11ayc0hqbb1nc">
      <Button type="button" size="lg" onClick={goToCheckout} aria-label="Comprar Atletismo Resuelto Sistema Completo" className="h-auto min-h-14 w-full max-w-[420px] rounded-xl border border-[#FFD66B]/35 bg-[#E3262E] px-6 py-4 shadow-[0_12px_38px_rgba(227,38,46,0.3)] transition-[transform,background-color,box-shadow] duration-200 ease-out hover:-translate-y-0.5 hover:bg-[#C81724] hover:shadow-[0_16px_44px_rgba(227,38,46,0.4)] focus-visible:ring-[#FFD66B] sm:w-auto sm:min-w-[380px]" data-id="element-180" data-mp="whdcumczg1mk">
        <span className="group flex w-full flex-wrap items-center justify-center gap-x-2 gap-y-0.5 text-center text-[13px] font-black leading-tight tracking-wide text-white sm:flex-nowrap sm:whitespace-nowrap sm:text-base" data-id="element-181" data-mp="3m05jp32teotc">
          {displayLabel}
          <ArrowRight className="size-5 shrink-0 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" data-id="element-182" data-mp="1kz7rj9x686qf" />
        </span>
      </Button>

      <div className="inline-flex max-w-full flex-wrap items-center justify-center gap-x-4 gap-y-1.5 rounded-full border border-white/10 bg-[#0A1830] px-4 py-2 sm:gap-x-5 sm:px-5" data-id="element-183" data-mp="1uu9hg7z9tcu2">
        {supportSegments.map(segment => {
        const {
          Icon,
          color
        } = getSupportIcon(segment);
        return <span key={segment} className="inline-flex items-center gap-1.5 text-xs font-semibold text-[#C7CED8] sm:text-sm" data-id="element-184" data-mp="28sze5mi6hahw">
              <Icon className="size-3.5 shrink-0" style={{
            color
          }} aria-hidden="true" data-id="element-185" data-mp="2ikn9hyhuvbon" />
              {segment}
            </span>;
      })}
      </div>
    </div>;
}